import React from 'react';
import BookletSelectedCompaniesPopup from './BookletSelectedCompaniesPopup';
import BookletCouponsReviewPopup from './BookletCouponsReviewPopup';

function BookletInCompanyColumn(props) {
  const { coupons, selectedCouponIds, setSelectedCouponIds, booklet, contactEmails, zoneId, isCompanyInView, company, companyHeight, companyIndex, bookletIndex, refetchCoupons, onOpenBulkEditor } = props;
  return (
    <td rowSpan={coupons.length} className={`pop-up-base`}>
      <BookletSelectedCompaniesPopup
        booklet={booklet}
        company={company}
        companyHeight={companyHeight}
        companyIndex={companyIndex}
        bookletIndex={bookletIndex}
        coupons={coupons}
      />
      <BookletCouponsReviewPopup
        coupons={coupons}
        selectedCouponIds={selectedCouponIds}
        setSelectedCouponIds={setSelectedCouponIds}
        booklet={booklet}
        company={company}
        companyId={company._id}
        contactEmails={contactEmails}
        zoneId={zoneId}
        isCompanyInView={isCompanyInView}
        companyHeight={companyHeight}
        refetchCoupons={refetchCoupons}
        onOpenBulkEditor={onOpenBulkEditor}
      />
    </td>
  )
}

export default BookletInCompanyColumn;
